import { CERTIFIED_THRESHOLD } from "@/constants/company/certification"

export function formatRankDisplay(
  rank: number,
  poolSize: number,
  trustScore: number
) {
  const isTarget = trustScore >= CERTIFIED_THRESHOLD
  const isTopFivePercent = rank <= poolSize * 0.05
  // If target but rank is greater than 10 while in top 5%, use percentile display
  if (isTarget && rank >= 10 && isTopFivePercent) {
    return "Top 5%"
  }
  return `#${rank} of ${poolSize}`
}
